// extracted by mini-css-extract-plugin
export default {"userInfo":"UserInfo_userInfo__tjfbX","badgeWrapper":"UserInfo_badgeWrapper__CXCgg","userItem":"UserInfo_userItem__93UeC","medal":"UserInfo_medal__n6xwR"};